var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_528_361)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.1423 4.42871H10.8566C6.81597 4.42871 4.79567 4.42871 3.54041 5.68397C2.63662 6.58776 2.38356 7.88816 2.31271 10.0537H23.6862C23.6153 7.88816 23.3623 6.58776 22.4585 5.68397C21.2032 4.42871 19.1829 4.42871 15.1423 4.42871Z",
    fill: "url(#paint0_linear_528_361)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8566 21.5716H15.1423C19.1829 21.5716 21.2032 21.5716 22.4585 20.3163C23.7137 19.0611 23.7137 17.0407 23.7137 13.0001C23.7137 12.5266 23.7137 12.0809 23.7117 11.6609H2.28718C2.28516 12.0809 2.28516 12.5266 2.28516 13.0001C2.28516 17.0407 2.28516 19.0611 3.54041 20.3163C4.79567 21.5716 6.81597 21.5716 10.8566 21.5716Z",
    fill: "url(#paint1_linear_528_361)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.7673 17.2859C5.7673 16.8421 6.12707 16.4823 6.57087 16.4823H10.8566C11.3004 16.4823 11.6602 16.8421 11.6602 17.2859C11.6602 17.7297 11.3004 18.0894 10.8566 18.0894H6.57087C6.12707 18.0894 5.7673 17.7297 5.7673 17.2859Z",
    fill: "url(#paint2_linear_528_361)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7316 17.2859C12.7316 16.8421 13.0914 16.4823 13.5352 16.4823H15.1423C15.5861 16.4823 15.9459 16.8421 15.9459 17.2859C15.9459 17.7297 15.5861 18.0894 15.1423 18.0894H13.5352C13.0914 18.0894 12.7316 17.7297 12.7316 17.2859Z",
    fill: "url(#paint3_linear_528_361)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_528_361",
    x: 0.142578,
    y: -0.856934,
    width: 25.7139,
    height: 26.7144,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.65
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.9 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_528_361"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_528_361",
    x1: 3.2539,
    y1: 6.90621,
    x2: 25.7166,
    y2: 11.2762,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2BBFFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.521875,
    stopColor: "#8629FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC4AF5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_528_361",
    x1: 3.2539,
    y1: 6.90621,
    x2: 25.7166,
    y2: 11.2762,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2BBFFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.521875,
    stopColor: "#8629FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC4AF5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_528_361",
    x1: 3.2539,
    y1: 6.90621,
    x2: 25.7166,
    y2: 11.2762,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2BBFFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.521875,
    stopColor: "#8629FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC4AF5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_528_361",
    x1: 3.2539,
    y1: 6.90621,
    x2: 25.7166,
    y2: 11.2762,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2BBFFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.521875,
    stopColor: "#8629FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC4AF5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardIcon);
export default __webpack_public_path__ + "static/media/card-icon.7a6b86d51b6ad35b0c01615f44677a8f.svg";
export { ForwardRef as ReactComponent };